// extracted by mini-css-extract-plugin
export default {"formContainer":"login_formContainer__SLk2L","loginTitle":"login_loginTitle__ZqVuY"};